import Reveal from "./Reveal";

/** Webpack-bundled logos — jpeg/png survive Amplify SPA rewrite (webp under /brand/ needs amplify.yml fix). */
import founderHub from "../../images/founder-hub.jpeg";
import awsStartup from "../../images/aws-startup.jpeg";
import nvidia from "../../images/nvidia.jpeg";
import iitmic from "../../images/IITMIC_logo.png";
import tides from "../../images/tidess.png";
import venturee from "../../images/venturee.png";
import brics from "../../images/bricss.png";

const PARTNERS = [
  { src: founderHub, alt: "Microsoft for Startups Founders Hub", width: 120, height: 48 },
  { src: venturee, alt: "NIDHI Entrepreneur-in-Residence", width: 120, height: 48 },
  { src: iitmic, alt: "IIT Madras Incubation Cell", width: 120, height: 48 },
  { src: tides, alt: "TIDES IIT Roorkee", width: 120, height: 48 },
  { src: awsStartup, alt: "AWS Startup", width: 120, height: 48 },
  { src: nvidia, alt: "NVIDIA", width: 120, height: 48 },
  { src: brics, alt: "BRICS WBA", width: 120, height: 48 },
];

export default function SupportedByLogos({ compact = false }) {
  return (
    <section
      className={`supported-by-section${compact ? " supported-by-section--compact" : ""}`}
      aria-label="Supported by"
    >
      <div className="wrap">
        <Reveal className="supported-by-inner">
          <h2 className="section-title supported-by-title">
            Backed by <b>leading programs</b>
          </h2>
          <ul className="supported-by-logos">
            {PARTNERS.map((partner) => (
              <li className="supported-by-logo" key={partner.alt}>
                <img
                  src={partner.src}
                  alt={partner.alt}
                  width={partner.width}
                  height={partner.height}
                  loading="lazy"
                  decoding="async"
                />
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
